<template>
    <div class="af" >
        <el-form class="table" v-loading="loading" :model="formData" :rules="formRules" ref="formRef"  size="mini">
            <div class="">
                <el-form-item class="form-title num flex" prop="num" :label="$t('saleInvoicing_sales_number')" >
                    <span  style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.vc_xcode}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_customer')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_khname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_invoice_leixing')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_invoice_type}}</span>
                </el-form-item>
                <el-form-item class="long form-title flex" prop="gsname" :label="$t('saleInvoicing_order_quantity_outbound_quantity_signed_receipt_quantity')" >
                    <span  style="display: inline-block;width: 100%">{{formData.f_kdnum+'/'+formData.f_outnum+'/'+formData.f_signnum+'/'+formData.f_backnum}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_order_item_name')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_pzname+' '+formData.vc_pzspecs+formData.vc_cd+formData.vc_gykh}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_order_unit')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_unit}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_order_unit_price')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzsymbol+formData.f_price}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_invoice_item_name')" >
                    <!--<span  style="display: inline-block;width: 100%">{{formData.vc_kpname_sell}}</span>-->
                    <el-input class="wid100"  v-model="formData.vc_kpname_sell">
                    </el-input>
                </el-form-item>

                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_billing_entity')" >
                    <!-- <span  style="display: inline-block;width: 100%">{{formData.vc_kpunit_sell}}</span>-->
                    <el-select style="width: 100%"  @change="changeData($event,'unit')"  class="marr4" v-model="formData.vc_kpunit_sell" size="mini" clearable filterable placeholder="请选择开票单位">
                        <el-option
                                v-for="item in unitData"
                                :key="item.vc_unitsconvert"
                                :label="item.vc_unitsconvert"
                                :value="item.vc_unitsconvert">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="long form-title flex" prop="gsname" :label="$t('saleInvoicing_pending_invoicing_order_volume')" >
                    <span  style="display: inline-block;width: 100%">{{formData.f_validnum}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_specification')" >
                    <el-input class="wid100"  v-model="formData.vc_kpbzstyle_sell">
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_invoice_customer')" >
                    <el-select style="width: 100%"  @change="changeData($event,'kpkh')"  class="marr4" v-model="formData.vc_kpkhname" size="mini" filterable >
                        <el-option
                                v-for="item in kpkhList"
                                :key="item.i_kpkhid"
                                :label="item.vc_kpkhname"
                                :value="item.vc_kpkhname">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title flex" prop="" :label="$t('saleInvoicing_billing_information')" >
                    <div class="" style="color: #3e82e8" @click="editkp">{{$t('saleInvoicing_edit')}}</div>
                </el-form-item>
                <!--<div class="form-title flex">
                    <div style="min-width: 84px;padding-left: 10px">开票资料</div>
                    <div class="" style="color: #3e82e8" @click="editkp">编辑</div>
                </div>-->
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_unit_price_on_invoice')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzsymbol+formData.f_kpprice_sell}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_invoice_quantity')" >
                    <!--<el-input-number @change="changenum" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  size="mini" v-model="formData.f_kpnum_sell" ></el-input-number>-->
                    <span  style="display: inline-block;">{{formData.f_kpnum_sell}}</span>
                    <span style="color: #3e82e8;margin-left: 10px" @click="openOrder">{{$t('saleInvoicing_associated_outbound_order')+'+'}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_kaipiao_amount')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzsymbol+formData.f_amount}}</span>
                </el-form-item>
            </div>
            <!--<div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" label="开票金额" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzsymbol+formData.f_amount}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" label="开票数量" >
                    <el-input class="wid100"  v-model="formData.f_num" @change="changenum">
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" label="订单单价" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzsymbol+formData.f_price}}</span>
                </el-form-item>
            </div>-->



            <div class="flex borb marTB6">


            </div>
            <div class="flex borb">
                <el-form-item class="long form-title flex" prop="gsname" :label="$t('saleInvoicing_customer_taxpayer_identification_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_creditcode}}</span>
                </el-form-item>
                <el-form-item class="long form-title flex" prop="gsname" :label="$t('saleInvoicing_opening_bank_and_account_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bank+' '+formData.vc_bank_account}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_address_telephone')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_address+' '+formData.vc_tel}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleInvoicing_email')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_email}}</span>
                </el-form-item>
            </div>
            <el-form-item class="flex wid100_bz" prop="vc_note" :label="$t('saleInvoicing_invoice_remarks')" >
                <el-input class="wid100"  v-model="formData.vc_note">
                </el-input>
            </el-form-item>
            <el-form-item class="flex wid100_bz" prop="vc_lruname" :label="$t('saleInvoicing_business')" >
                <el-input class="wid100"  v-model="formData.vc_kduname" disabled>
                </el-input>
            </el-form-item>
            <!--<div class="flex">
                <el-form-item class="flex wid50" prop="vc_lruname" label="业务" >
                    <el-input class="wid100"  v-model="formData.vc_kduname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="flex wid50" prop="date" label="日期" >
                    <el-input  class="wid100" v-model="formData.dt_createtime" disabled>
                    </el-input>
                </el-form-item>
            </div>-->
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('saleInvoicing_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('saleInvoicing_edit_invoice_information')"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible"
                :append-to-body="true">
            <kp-infor :Data="kpData" @close="cancelDialog"></kp-infor>
        </el-dialog>
        <el-dialog
                :class="baseerp+'div'"
                width="80%"
                :title="$t('saleInvoicing_associated_outbound_order')"
                :visible.sync="dialogVisible_gl"
                :close-on-click-modal="false"
                @close="handleConfirm"
                v-if="dialogVisible_gl"
                :append-to-body="true">
            <add-order :orderData="orderData" @close="handleConfirm"></add-order>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import kpInfor from "./kpInfor"
    import addOrder from "./addOrder";
    export default {
        name: "",
        components: {
            kpInfor,addOrder,
        },
        props:{
            addData:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                copybl:1,
                copyvaildnum:0,
                unitData:[],
                kpData:{},
                orderData:{},
                dialogVisible:false,
                dialogVisible_gl:false,
                loading:false,
                isbtn:false,
                isedit:false,
                ismoren:false,
                formData:{
                    subDetails:[],
                },
                formRules:{
                    //f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],
                },
                visible:false,
                disabled:false,
                edit:false,
                baseerp:"",
                mid:0,
                kpkhList:[],
                select:[],
            }
        },

        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            //console.log(this.addData,'addData');
            console.log(this.addData.i_state,'this.addData.i_state');
            console.log(this.addData.i_invoice_source,'this.addData.i_invoice_source');
            console.log(this.addData.i_order_source,'this.addData.i_order_source');
            this.formData=this.deepClone(this.addData.item);
            this.copyvaildnum=this.formData.f_num;
            this.copybl=this.formData.f_bl;
            this.formData.i_kpkhid=this.formData.i_khid;
            this.formData.vc_kpkhname=this.formData.vc_khname;
            //this.formData.f_validnum= parseFloat((this.formData.f_num / this.formData.f_bl).toFixed(this.$setPrecision.quantityPrecision));
            //this.formData.f_kpnum_sell=this.formData.f_num;
            this.formData.f_validnum=this.formData.f_num;
            this.formData.f_kpnum_sell=this.formData.f_num*this.formData.f_bl;
            let f_kpprice_sell = this.formData.f_price / this.formData.f_bl;
            //this.formData.f_kpprice_sell = Math.round(parseFloat(f_kpprice_sell) * 100) / 100;
            this.formData.f_kpprice_sell =  parseFloat(f_kpprice_sell).toFixed(this.$setPrecision.quantityPrecision);
            //this.formData.ddnum=this.addData.item.f_kpnum_sell;
            //this.formData.validnum=this.addData.item.f_validnum;
            this.formData.ddnum=this.formData.f_kpnum_sell;
            this.formData.validnum=this.formData.f_validnum;
            let map={
                i_id:this.addData.item.i_khid,
                vc_name:this.addData.item.vc_khname,
            }
            this.kpkhList.push(map);
            this.getUnitList();
            this.getKhBaseInfo();
            this.updateTableHeight();
            window.addEventListener('resize', this.updateTableHeight);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods:{
            updateTableHeight() {
                //console.log(this.addData.maxDialogHeight,'this.addData.maxDialogHeight');
                const dialogHeight = this.addData.maxDialogHeight * 0.95; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight =450;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.addData.maxDialogHeight;
            },
            openOrder(){
                let map={
                    "vc_xcode":this.formData.vc_xcode,
                    "i_pzid":this.formData.i_pzid,
                };
                this.orderData={
                    map:map,
                    //ddnum:this.formData.ddnum,
                    validnum:this.formData.f_validnum,
                    //validnum:this.formData.f_kpnum_sell,
                    kpnum:this.formData.f_kpnum_sell,
                    f_bl:this.formData.f_bl,
                    vc_unit:this.formData.vc_unit,
                    vc_kpunit_sell:this.formData.vc_kpunit_sell,
                    select:this.select,
                    maxDialogHeight:this.maxDialogHeight,
                    f_kpprice_sell:this.formData.f_kpprice_sell,
                    i_order_source:this.addData.i_order_source,
                }
                this.dialogVisible_gl=true;
            },
            handleConfirm(selectedRows,kpnum){
                this.dialogVisible_gl=false;
                //console.log('selectedRows',selectedRows,'kpnum',kpnum);
                this.select=selectedRows?selectedRows:[];
                this.formData.subDetails=selectedRows?selectedRows:[];
                this.formData.f_kpnum_sell=kpnum?kpnum:this.formData.f_kpnum_sell;
                //this.formData.f_validnum=kpnum?kpnum:this.formData.f_validnum;
                this.formData.f_num=kpnum?parseFloat((kpnum / this.formData.f_bl).toFixed(this.$setPrecision.quantityPrecision)):this.formData.f_num;
                this.formData.f_amount=parseFloat(this.formData.f_kpprice_sell*this.formData.f_kpnum_sell).toFixed(this.$setPrecision.quantityPrecision);
                },
            async getKhBaseInfo(){
                let param = {
                    i_mid:this.mid,
                    i_id:this.addData.item.i_khid,
                };
                let res = await API.getKhBaseInfo(param);
                if (res.code == 1) {
                    if(res.data.i_pid!=0){
                        let map={
                            i_id:res.data.i_pid,
                            vc_name:res.data.vc_pname,
                        }
                        this.kpkhList.push(map);
                    }else{
                        this.getSubCustomers()
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getSubCustomers(){
                let param = {
                    i_mid:this.mid,
                    i_id:this.addData.item.i_khid,
                };
                let res = await API.getSubCustomers(param);
                if (res.code == 1) {
                    this.kpkhList = [...this.kpkhList, ...res.data.subList];
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='unit'){
                    this.formData.vc_kpunit_sell=e;
                    let choo = this.unitData.filter(item=>{
                        return item.vc_unitsconvert == e
                    });
                    if(choo.length>0){
                        this.formData.f_bl=choo[0].f_bl;
                        let f_kpprice_sell = this.formData.f_price / choo[0].f_bl;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(f_kpprice_sell) * 100) / 100;
                        this.formData.f_kpprice_sell = parseFloat(f_kpprice_sell).toFixed(this.$setPrecision.quantityPrecision);
                        let validnum =0;
                            validnum=this.copyvaildnum*choo[0].f_bl;
                        this.formData.f_validnum =validnum;
                        //this.formData.f_kpnum_sell=this.formData.f_validnum;
                        this.formData.f_kpnum_sell=validnum;
                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                    }else{
                        this.formData.f_bl=1;
                        this.formData.f_kpprice_sell = this.formData.f_price*1;
                        this.formData.f_validnum =this.copyvaildnum;
                        this.formData.f_kpnum_sell=this.copyvaildnum;
                        this.formData.vc_kpunit_sell=this.formData.vc_unit;
                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                    }
                    this.select=[];
                    this.formData.subDetails=[];
                }
            },
            //单位换算
            async getUnitList(){
                let param = {
                    i_mid:this.mid,
                    vc_originunit:this.formData.vc_unit,
                };
                let res = await API.getUnitList(param);
                if (res.code == 1) {
                    this.unitData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            editkp(){
                this.kpData={
                    i_kpzlid:this.formData.i_kpzlid,
                    i_khid:this.formData.i_khid,
                    i_title_type:this.formData.i_title_type,
                    i_invoice_type:this.formData.i_invoice_type,
                    vc_invoice_type:this.formData.vc_invoice_type,
                    vc_creditcode:this.formData.vc_creditcode,
                    vc_bank:this.formData.vc_bank,
                    vc_bank_sub:this.formData.vc_bank_sub,
                    vc_bank_account:this.formData.vc_bank_account,
                    vc_address:this.formData.vc_address,
                    vc_tel:this.formData.vc_tel,
                    vc_email:this.formData.vc_email,
                }
                this.dialogVisible=true;
            },
            cancelDialog(val){
                this.kpData={};
                this.dialogVisible=false;
                if(val){
                    //this.$emit('cancelDialog_add',val);
                     //console.log(val,'val')
                     this.formData.i_title_type=val.i_title_type;
                     this.formData.i_invoice_type=val.i_invoice_type;
                     this.formData.vc_invoice_type=val.vc_invoice_type;
                     this.formData.vc_bank=val.vc_bank;
                     this.formData.vc_bank_sub=val.vc_bank_sub;
                     this.formData.vc_bank_account=val.vc_bank_account;
                     this.formData.vc_address=val.vc_address;
                     this.formData.vc_tel=val.vc_tel;
                     this.formData.vc_email=val.vc_email;
                }
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            changenum(e){
                // console.log('e',e)
                if(e>this.formData.f_validnum||e==0){
                    this.$message.error(this.$t('saleInvoicing_the_invoiced_quantity_cannot_exceed_the_quantity_to_be_invoiced_and_cannot_be_0'));
                    this.formData.f_kpnum_sell =this.formData.f_validnum;
                    this.formData.f_num = this.formData.f_validnum / 1
                }else{
                    this.formData.f_kpnum_sell = e;
                    let price = this.formData.f_kpnum_sell * this.formData.f_kpprice_sell;
                    this.formData.f_amount = Math.round(parseFloat(price) * 100) / 100;
                    this.formData.f_num = this.formData.f_kpnum_sell / this.formData.f_bl
                    /*let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                    this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;*/
                }
                //console.log( this.formData.f_num,' this.formData.f_num')
            },
            //保存
            async saveForm(){
                /*if(this.formData.vc_email==''){
                    this.$message.error('请去开票资料维护邮箱或银行账号！');
                    return;
                };*/
                /*if(this.formData.i_isspec!=1&&this.formData.vc_bank_account==''){
                    this.$message.error('请前往OA维护银行账号！');
                    return;
                };*/
                if(this.formData.vc_creditcode==''){
                    this.$message.error($t('saleInvoicing_please_go_to_the_oa_system_to_maintain_the_customer_s_taxpayer_identification_number'));
                    return;
                };
                if(this.formData.subDetails.length==0){
                    this.$message.error(this.$t('saleInvoicing_please_associate_the_outbound_order'));
                    return;
                };

                let alist=[];
                this.formData.i_state=this.addData.i_state;
                this.formData.i_invoice_source=this.addData.i_invoice_source;
                alist.push(this.formData);
                this.disabled=true;
                this.loading=true;
                let param={
                    delSub:[],
                    list:alist,
                    i_order_source:this.addData.i_order_source,
                };
                let res=await API.saveInvoice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.$emit('cancelDialog_add','new');
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('cancelDialog_add');
            },

        }
    }
</script>

<style  lang="scss" scoped>
    .marTB6{
        margin: 6px 0;
    }
    .point{
        font-size: 10px;
        color: #fa5050;
        height: 10px;
        line-height: 10px;
    }
    /deep/.el-input__suffix{
        right: 12px;
    }
    /deep/.nodata .el-input__inner{
        padding: 0 9px;
    }
    .wid100{
        width: 100%;
    }

    .mar3{
        margin:3px 0px;
    }
    .moren .el-form-item__label{
        width:150px !important;
    }
    .inputw{
        //width:calc(100% - 90px);
    }
    .wid50{
        width: calc(50% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .wid100_bz{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .mart20{
        margin-top: 20px;
    }
    .borb{
        //border-bottom: 1px solid #efefef;
        //margin-top: 1px;
    }
    .fr{
        float: right;
    }
    .wid60{
        width: 60%;
    }
    .width100_f{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .wid66{
        width: calc(66% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .form-title{
        //width: calc(33% - 30px) !important;
        flex: 1 1 50%;
        padding-right: 20px;
        padding-left: 10px;
        display: flex;
    }
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }

    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 150px;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    /deep/.guding{
        /*.el-form-item__label{*/
        /*    min-width: 85px !important;*/
        /*    margin-right: 3px !important;*/
        /*}*/
    }

    /deep/.table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
        .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 80px;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }
        .long .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 145px;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }
        .el-input--mini .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-form-item__content{
            width: 100%;
        }

    }
    /deep/.el-input-number--mini {
        width: 100% !important;
        //height: 24px;
        //line-height: 24px;
    }
    /deep/.el-input-number .el-input__inner{
        padding-left: 15px;
        padding-right: 0px;
        text-align: left;
    }

</style>
